<div class="layout-footer p-d-flex p-ai-center p-p-4 p-shadow-2" style="background-color: #ad1457">
    <img id="footer-logo" [src]="'assets/images/logo/logo.png'" alt="ultima-footer-logo" style="height: 3rem" />
</div>
